<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <agent-editor
            :agentId="agentId"
            isModal
            @saved="onAgentSaved"
          ></agent-editor>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import AgentEditor from "../agents/AgentEditor";
export default {
  name: "modal-agent-edit",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    AgentEditor,
  },

  computed: {
    agentId() {
      return this.value ? this.value.id : "";
    },
    title() {
      return this.value ? `Editing ${this.value.name} ` : "Editing Agent";
    },
  },

  methods: {
    onAgentSaved() {
      console.log("agent saved");
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ModalAgentEdit.vue